import { useAccount } from './useAccount'

export function useSegment() {
  return useAccount().segmentKey
}
